module.exports = __webpack_public_path__ + "static/img/no_data.4e58875.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/preview/images/no_data.png
// module id = Nk5p
// module chunks = 1